import React, { Suspense, lazy } from 'react';
// import { lazy } from './utils';
import { Route, Routes } from 'react-router-dom';

import FrontendLayout from './components/Layouts/Frontend';

import { SITE_TITLE } from './constants';
import './assets/scss/custom.scss';
// import AdminPage from  './components/Layouts/Backend/Admin';
const HomePage = lazy(() => import('./pages/Home'));
const AboutPage = lazy(() => import('./pages/About'));
const CareerPage = lazy(() => import('./pages/Careers'));
const CareerDetails = lazy(() => import('./pages/CareerDetails'));
const SchedulePage = lazy(() => import('./pages/Schedule'));
const ContactPage = lazy(() => import('./pages/Contact'));
const WorksPage = lazy(() => import('./components/Works'));
const RegisterPage = lazy(() => import('./pages/Register'));
const ConfirmEmailPage = lazy(() => import('./pages/ConfirmEmail'));
const LoginPage = lazy(() => import('./pages/Login'));
const ScanPage = lazy(() => import('./pages/Scan'));
const WelcomePage = lazy(() => import('./pages/Welcome'));
const ServicePage = lazy(() => import('./components/Services'));
const AdminPage = lazy(() => import('./components/Layouts/Backend/Admin'));
const ErrorPage = lazy(() => import('./pages/Error'));

function App() {
  document.title = SITE_TITLE;
  return (
    <div className='App'>
      <FrontendLayout>
        <Routes></Routes>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route exact path='/' element={<HomePage />} />
            <Route path='/about' element={<AboutPage />} />
            <Route path='/career' element={<CareerPage />} />
            <Route path='/contact' element={<ContactPage />} />
            <Route path='/schedule' element={<SchedulePage />} />
            <Route path='/contact/:id' element={<ContactPage />} />
            <Route path='/career/:id' element={<CareerDetails />} />
            <Route path='/services/:id' element={<ServicePage />} />
            <Route path='/services' element={<ServicePage />} />
            <Route path='/works' element={<WorksPage status='all' />} />
            <Route path='/signup' element={<RegisterPage />} />
            <Route path='/confirmEmail' element={<ConfirmEmailPage />} />
            <Route path='/scan' element={<ScanPage />} />
            <Route path='/signin' element={<LoginPage />} />
            <Route path='/welcome' element={<WelcomePage />} />
            <Route path='/admin' element={<AdminPage />} />
            <Route path='*' element={<ErrorPage />} />
          </Routes>
        </Suspense>
        <Routes></Routes>
      </FrontendLayout>
    </div>
  );
}

export default App;
